import React from 'react';
import GeckoFieldBase from '../_base.jsx';
import './react-select-plus.css';
import './select_multi.scss';
import Select from 'react-select-plus'; //https://github.com/HubSpot/react-select-plus

class GeckoFieldSelect extends GeckoFieldBase {
  constructor(props) {
    super(props);
    this.state = { value: this.value() };
  }

  componentDidUpdate() {
    const newValue = this.value();
    if (JSON.stringify(newValue) !== JSON.stringify(this.state.value)) {
      this.setState({ value: newValue });
    }
  }

  handleChange(option) {
    return this.props.handler.bind(
      this,
      this.field().key,
      this.prepareValue(option)
    )();
  }

  prepareValue(values) {
    return values.map((v) => v.value);
  }

  render() {
    const inputProps = Object.assign(
      { autoComplete: 'off' },
      this.config().inputProps || {}
    );
    return (
      <Select
        id={this.renderId()}
        className="gecko-ui-material"
        value={this.state.value}
        options={this.options()}
        optionRenderer={this.props.field.optionRenderer}
        onChange={this.handleChange.bind(this)}
        multi={true}
        disabled={this.isDisabled()}
        placeholder={this.field().placeholder}
        inputProps={inputProps}
        {...this.config()}
      />
    );
  }
}

export default GeckoFieldSelect;
